import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "API Keys", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "buttons" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "columns is-multiline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_item = _resolveComponent("v-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    (!_ctx.loading('getApiKeys'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiKeys, (apiKey, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "column is-one-quarter",
              key: apiKey.name
            }, [
              _createVNode(_component_v_item, {
                title: 'Name: ' + apiKey.name,
                summary: 'Plan: ' + apiKey.planType + ', Status: ' + apiKey.status.replace(':','&') + ((apiKey.customerId != '')?(', Customer ID: ' + apiKey.customerId):''),
                index: index,
                canView: true,
                onView: ($event: any) => (_ctx.viewApiKey(index))
              }, null, 8, ["title", "summary", "index", "onView"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}